'use client'

import { createContext, useLayoutEffect, PropsWithChildren } from 'react'
import { defineCustomElements } from '@alice-health/wonderland-react'

// to warn users about missing WonderlandDesignSystemProvider, we set the default values as undefined
export const WonderlandDesignSystemContext = createContext('on-light')

type Props = {
  // other component configurations should probably go into a separate `components`, `componentProps` or `componentDefaults`
  // property similar to https://mui.com/material-ui/customization/theme-components/
}

export const WonderlandDesignSystemProvider = ({
  ...props
}: PropsWithChildren<Props>): JSX.Element => {
  useLayoutEffect(() => {
    defineCustomElements(window)
  }, [])

  return (
    <WonderlandDesignSystemContext.Provider
      value='on-light'
      {...props}
    />
  )
}
